/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "backbone",
    "i18n/i18n",
    "service/channel_factory",
    "api/v2/common",
    "underscore",
    "service/ajax_channel",
    "api/v2/sourceinfo",
  ], function(
    Backbone,
    i18n,
    ChannelFactory,
    Common,
    _,
    AjaxChannel,
    SourceInfo
) {
  
  /*
    TODO: differentiate between channels and 
          sources
   */
  var Channels = Backbone.Collection.extend({

    initialize: function(model, options) {
      Backbone.Collection.prototype.initialize.apply(this, arguments);

      let factoryOptions = Object.assign({prepareRequest: this.prepareRequest.bind(this)}, options);
      this.channelFactory = new ChannelFactory(factoryOptions);
      this.alerts = new Backbone.Collection();
      this.options = options;

      this.listenTo(this, "done", this.checkMessages);
      this.listenTo(this, "fail", this.failedCall);
    },

    failedCall: function (channel, response) {
      if (response && response.path === 'suggest') {
        if (response.error === "timeout") {
          console.warn( "Suggest request timeout  (" + response.url  + ")");
          return;
        }
        if (response.error === "error") {
          console.error( "Suggest request error  (" + response.url  + ")");
          return;
        }
      }
      var message = "<strong>" + i18n("Error") + "</strong> " + response.error + " (" + response.url  + ")";      
      this.addAlert({
          id: message,
          level: "error",
          message: message
      });
    },

    checkMessages: function (channel, response) {
      if (!response) return;
      this.addAlerts(response.status_messages);
    },

    addAlerts: function (status_messages) {
      status_messages = Common.StatusMessages.parse(status_messages);
      var that = this;

      _.each(status_messages, function (model, id) {
        if (id === "timeout" || id == "no_results") return;

        model = _.clone(model);
        model.id = id;
        model.level = model.error ? "error" : model.warning ? "warning" : "info";
        model.service_ids = model.service_ids && model.service_ids.join(", ");
        that.addAlert(model);
      });
    },

    addAlert: function (model) {
      if (model && model.hidden) return;
      this.alerts.add(model);
    },

    add: function(models, channelOptions) {
      models = _.isArray(models) ? models.slice() : [models];
      var i, modelOrAttr, that = this, args = arguments, failedSourceinfoCalls = {};

      for (i = models.length - 1; i >= 0; i--) {
        modelOrAttr = models[i];
        if (
          modelOrAttr instanceof Backbone.Model ||
          (_.isObject(modelOrAttr) && modelOrAttr.channelType !== undefined)
        ) {
          Backbone.Collection.prototype.add.apply(that, args);
          continue;
        }

        if (_.isString(modelOrAttr)) {
          modelOrAttr = {url: modelOrAttr};
        }

        modelOrAttr.channelType = 'MessageFrameChannel';
        if (channelOptions && channelOptions.useMessageFrameForNonBuiltinSources === false) {
          modelOrAttr.channelType = 'CrossDomainAjaxChannel';
        }

        args[0] = modelOrAttr;
        Backbone.Collection.prototype.add.apply(that, args);
      }
    },

    _prepareModel: function(attrs, options) {
      var ch = this.channelFactory.createChannel(attrs, options);
      ch.prepareRequest = _.bind(this.prepareRequest, this, ch);
      
      return ch;
    },

    prepareRequest: function(channel, request) {
      try {
        if (!request.user_context) {
          request.user_context = {};
        }
        if (_.isObject(request.user_context)) {
          if (this.options && this.options.referer) {
            request.user_context.referer = this.options.referer || request.user_context.referer;
          } 
          if (this.options && this.options.sessionDescription) {
            request.user_context.session_description = this.options.sessionDescription || request.user_context.session_description;
          }
          if (this.options && this.options.organizationId) {
            request.user_context.organization_id = this.options.organizationId || request.user_context.organization_id;
          }
          if (this.options && this.options.teamId) {
            request.user_context.team_id = this.options.teamId || request.user_context.team_id;
          }
          request.user_context.locale = i18n.locale;
          request.user_context.service_id = (channel.get) ? channel.get("id") : channel.id;
          request.user_context.utc_time_zone_differential_in_seconds = (-new Date().getTimezoneOffset() * 60);

          if (request.path === "search"
            && channel
            && channel.options
            && channel.options.application
            && channel.options.application.models
            && channel.options.application.models.searchSettings) {
              var properties = this.getUserContextProperties(channel.options.application.models.searchSettings);
              if (properties.length) request.user_context.properties = properties;
          }

        }
      } catch (e) {
        if (console && console.warn)  
          console.warn("Failed to prepare request", e);
      }
      return this;
    },

    getUserContextProperties: function (collection) {
      var properties = [];
      if (collection && collection.length) {
        collection.each(function (model) {
          var state = model.get("checked") === true || false;
          if (!state) {
            properties.push({
              key: model.get("key"),
              value: !state + ""
            }); 
          }
        });
      }
      return properties;
    }

  });

  Channels.ignoreSuccessiveErrorsCallback = function(channel, error) {

    var channels = _.isFunction(this.channels) && this.channels() || !_.isFunction(this.channels) && this.channels || null;
    if (!this.callback || !channels) 
      return;

    var ctx = this;    
    if (!ctx.failedChannels) {
      ctx.failedChannels = {};
    }
    
    var errorStatus = -1;
    if (error && error.status) 
      errorStatus = error.status;
    
    if (channel && channel.id) {
      // ignore successively failed channels.
      if (!ctx.failedChannels[channel.id]) {
        ctx.failedChannels[channel.id] = [];
      }
      
      if (_.contains(ctx.failedChannels[channel.id], errorStatus)) {
        return;
      }
      else 
      {
        ctx.failedChannels[channel.id] = _.union(ctx.failedChannels[channel.id], [errorStatus]);
      }
    
      if (ctx.failedChannels[channel.id] && ctx.failedChannels[channel.id].length == 1) {
        // reset once ..
        channels.once("done", function(channel) {
          if (!channel || !channel.id) {
            ctx.failedChannels = {};
          }
          else {
            if (ctx.failedChannels) {
              delete ctx.failedChannels[channel.id];
            }
          }
        });
      }
    }
      // call the callback ..
    return this.callback.apply(this.context, arguments);
  }

  return Channels;

});
